
import './order-placed.css';
import { useContext, useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { cartContext } from '../../App';
import HeaderOther from '../ui/header-other';
import { Player } from '@lottiefiles/react-lottie-player';
import orderConfirmed from '../data/order-confirmed.json'; // Path to your JSON file
import packingOrder from '../data/packing-order.json'
import orderOnTheWay from '../data/on-the-way.json';
import orderCancelled from '../data/order-cancelled.json';
import orderDelivered from '../data/order-delivered.json';
import DeliveryTime from '../subcomponents/deliveryTime';

export default function OrderPlaced() {
    const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
    const AUTH_TOKEN = process.env.REACT_APP_AUTH_TOKEN;

    //status variable and json
    const [animatedStatus, setAnimatedStatus] = useState();
    const [orderStatus, setOrderStatus] = useState(null);

    //get order details from prev page
    const location = useLocation();
    const { orderItem, status } = location.state || {};
    console.log('order items: ', orderItem)

    useEffect(() => {
        if (status === 'Placed') {
            setOrderStatus('Your order has been placed!');
            setAnimatedStatus(orderConfirmed);
        } else if (status === 'Getting Packed') {
            setOrderStatus('Your order is getting packed!');
            setAnimatedStatus(packingOrder);
        } else if (status === 'On The Way') {
            setOrderStatus('Rider is on the Way!');
            setAnimatedStatus(orderOnTheWay);
        } else if (status === 'Cancelled') {
            setOrderStatus('Your order has been cancelled!');
            setAnimatedStatus(orderCancelled);
        } else if (status === 'Delivered') {
            setOrderStatus('Your order has been Delivered!');
            setAnimatedStatus(orderDelivered);
        }
    }, [status]);

    const { extraData } = useContext(cartContext);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);

    //address from orderItems
    const add = orderItem.address?.address;
    const name = add?.name
    const properAddress = add?.addressLine1 + add?.addressLine2 + add?.area
    const phone = add?.phone

    const navigate = useNavigate();

    const orderItems = orderItem.cartItem;
    const orderNumber = orderItem.orderNumber;
    const orderTime = orderItem.orderTime;
    const orderTotal = orderItem.orderTotal;
    const savingsValue = orderItem.savingsValue;
    // const deliverCharge = (orderTotal - extraData.data.deliveryFee) > extraData.data.minOrderValueFee ? 0 : Number(extraData.data.deliveryFee);


    function handleCancel() {

        const dataToSend = {
            orderNo: orderNumber,
            orderItems: orderItems
        }

        fetch(`${BACKEND_URL}/cancel-order`, {
            method: 'post',
            headers: {
                'Authorization': `Bearer ${AUTH_TOKEN}`,  // Send token in header 
                'content-type': 'application/json'
            },
            body: JSON.stringify(dataToSend),
        })
        .then((response) => response.json())
        .then((data) => {
            console.log(data)
            navigate('/orders');
        }).catch((error) => {
            console.log(error)
            setError(true)
            setTimeout(() => {
                navigate('/orders');
            }, 3000)
        })
        .finally(
            setLoading(true)
        )

    }

    if (error) {
        return (
            <div style={{display:'flex', flexDirection:'column', justifyContent:'center', alignItems:'center', height:'100vh'}}>
                <img src='/brand-icons/freslo-full-icon.png' alt='freslo logo' style={{ width: '220px', height: 'auto' }}></img>
                <p style={{fontSize:'24px', fontWeight:'bold', fontFamily:'Arial', color:'rgba(227, 47, 47, 0.927)'}}>Something went Wrong!</p>
            </div>
          );
    }

    if (loading) {
        return (
            <div style={{display:'flex', flexDirection:'column', justifyContent:'center', alignItems:'center', height:'100vh'}}>
                <img className='loading-img' src='/brand-icons/freslo-full-icon.png' alt='freslo logo' style={{ width: '220px', height: 'auto', marginBottom: '30px' }}></img>
                <p style={{fontSize:'24px', fontWeight:'bold', fontFamily:'Arial', color:'rgba(227, 47, 47, 0.927)'}}>Cancelling Your Order...</p>
            </div>
          );
    }

    return (
        <>
            <HeaderOther title='Order Details' description={ `Order #${orderNumber}` } />
            <div className='orders-box'>

                {
                    status !== null ? ( 
                        <>
                            {
                                status === 'Cancelled' ? 
                                    <p className='order-status-text' style={{color:'red'}}>{orderStatus}</p> :
                                    <p className='order-status-text'>{ orderStatus }</p>
                            }
                            <div className='status-container'>
                                <Player
                                    autoplay
                                    loop
                                    src={animatedStatus}
                                    style={{ height: '200px', width: '100%' }} // Adjust size as needed
                                />
                                <div className='status-indicator-box'>
                                    <div className='status-indicator'>
                                        <div className='status-indicator-line-box'>
                                            <div className='status-indicator-line' style={{backgroundColor: '#2c5f2d'}}></div>
                                            <div className='status-indicator-circle' style={{backgroundColor: '#2c5f2d'}}></div>
                                        </div>
                                        <p className='status-indicator-text'>Confirmed</p>
                                    </div>

                                    <div className='status-indicator'>
                                        <div className='status-indicator-line-box'>
                                            <div className='status-indicator-line' style={{backgroundColor: ['Getting Packed','On The Way','Delivered','Cancelled'].includes(status) && '#2c5f2d'}}></div>
                                            <div className='status-indicator-circle' style={{backgroundColor: ['Getting Packed','On The Way','Delivered','Cancelled'].includes(status) && '#2c5f2d'}}></div>
                                        </div>
                                        <p className='status-indicator-text'>Packing</p>
                                    </div>

                                    <div className='status-indicator'>
                                        <div className='status-indicator-line-box'>
                                            <div className='status-indicator-line' style={{backgroundColor: ['On The Way','Delivered','Cancelled'].includes(status) && '#2c5f2d'}}></div>
                                            <div className='status-indicator-circle' style={{backgroundColor: ['On The Way','Delivered','Cancelled'].includes(status) && '#2c5f2d'}}></div>
                                        </div>
                                        <p className='status-indicator-text'>On The Way</p>
                                    </div>

                                    <div className='status-indicator'>
                                        <div className='status-indicator-line-box'>
                                            <div className='status-indicator-line' style={{backgroundColor: status === 'Delivered' ? '#2c5f2d' : status === 'Cancelled' && 'red'}}></div>
                                            <div className='status-indicator-circle' style={{backgroundColor: status === 'Delivered' ? '#2c5f2d' : status === 'Cancelled' && 'red'}}></div>
                                        </div>
                                        <p className='status-indicator-text' style={{ color: status === 'Cancelled' && 'red' }}>{ status === 'Cancelled' ? 'Cancelled' : 'Delivered' }</p>
                                    </div>
                                </div>
                            </div>
                            
                        </>
                    ) : (
                        <></>
                    )
                }
                
                {
                    status !== 'Delivered' && status !== 'Cancelled' && <DeliveryTime />
                }
        
                <div className='order-container'>
                    <p className='order-placed-total-item'>{ orderItems.length } items in this order</p>
                    {
                        orderItems.map((data, index) => (
                            <div key={ index } className='placed-items'>
                                <div className='placed-item-details'>
                                    <div className='placed-item-pic'>
                                        <img className='placed-pic' src={data.details.images[0]} />
                                    </div>
                                    <div className='placed-item-title'>
                                        <p className='placed-title-name'>{data.details.title.length > 25 ? data.details.title.slice(0, 25) + "..." : data.details.title}</p>
                                        <p className='placed-weight' style={{color:'black', paddingLeft:'0'}}>{data.details.weight}</p>
                                    </div>
                                </div>
                                <div className='placed-item-left'>
                                    <div className='placed-item-price'>
                                        {
                                            Number(data.details.mrp) - Number(data.details.price) != 0 &&
                                            <span className='wrong-price' style={{fontSize:'12px'}}><span style={{fontFamily:'Arial'}}>&#8377;</span>{Math.round(data.details.mrp)}</span>
                                        }
                                        <span style={{ fontSize: '12px' }}><span style={{fontFamily:'Arial'}}>&#8377;</span>{Math.round(data.details.price)} X { data.qty }</span>
                                    </div>
                                </div>
                            </div>
                        ))
                    }
                    
                </div>
                <div className='order-value-container'>
                    <div className='placed-order-total'>
                        <p className='item-total-margin'>Order No: </p>
                        <p className='item-total-margin'>{orderNumber}</p>
                    </div>
                    <div className='placed-order-total'>
                        <p className='item-total-margin'>Placed on: </p>
                        <p className='item-total-margin'>{orderTime}</p>
                    </div>
                    {/* <div className='placed-order-total'>
                        <p className='item-total-margin'>Delivery Fee: </p>
                        {
                            deliverCharge === 0 ?
                                <p className='item-total-margin' style={{color:'green'}}>Free <span className='item-total-margin-final' style={{textDecoration:'line-through'}}><span style={{fontFamily:'Arial'}}>&#8377;</span>{extraData.data.deliveryFee}</span></p> :
                                <p className='item-total-margin-final' style={{marginBottom:'7px'}}><span style={{fontFamily:'Arial'}}>&#8377;</span>{deliverCharge}</p>
                        }
                    </div> */}
                    <div className='placed-order-total'>
                        <p className='item-total-margin'>Saved: </p>
                        <p className='item-total-margin' style={{color: 'green'}}>-<span style={{fontFamily:'Arial'}}>&#8377;</span>{savingsValue}</p>
                    </div>
                    <div className='placed-order-total' style={{borderTopWidth: '1px', borderTopColor: 'black', borderTopStyle: 'solid'}}>
                        <p className='item-total-margin' style={{fontWeight: 'bold'}}>Order Total: </p>
                        <p className='item-total-margin' style={{fontWeight: 'bold'}}><span style={{fontFamily:'Arial'}}>&#8377;</span>{orderTotal}</p>
                    </div>
                    
                </div>  
                <div className='saved-box'>
                    <p className='saved'>&#x2726; You Saved <span style={{fontFamily:'Arial'}}>&#8377;</span>{savingsValue}! &#x2726;</p>
                </div>

                <div className='open-box-delivery-container-placed'>
                    <img src='/icons/carton-box.png' alt='open-box-logo' style={{width:'45px', height:'45px', margin:'5px 5px 0 10px'}}/>
                    <div>
                        <p className='item-total-margin' style={{ fontSize: '16px', fontWeight:'bold'}}>Shop confidently with Open Box Delivery</p>
                        <p className='item-total-margin' style={{ fontSize: '12px', marginRight:'5px' }}>
                            The agent will <b>open the package</b> at your doorstep,
                            kindly <b>check and return</b> for damaged or incorrect item, and report any missing item at the doorstep only.
                        </p>
                    </div>                    
                </div>

                {
                    status === 'Delivered' || status === 'Cancelled' ? 
                        (
                            <div className='delivery-timing'>
                                <p className='arriving-symbol'>Address</p>
                                <div className='arriving-address' style={{marginBottom:'10px'}}>
                                    <div>
                                        <p className='proper-add'>{ name },</p>
                                        <p className='proper-add'>{ properAddress }</p>
                                        <p className='proper-add' style={{marginTop:'5px'}}>{ phone }</p>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <div className='delivery-timing'>
                                <p className='arriving-symbol'>Arriving To</p>
                                <div className='arriving-address' style={{marginBottom:'10px'}}>
                                    <div>
                                        <p className='proper-add'>{ name },</p>
                                        <p className='proper-add'>{ properAddress }</p>
                                        <p className='proper-add' style={{marginTop:'5px'}}>{ phone }</p>
                                    </div>
                                </div>
                            </div>
                        )
                }

                <a className='delivery-timing' target='blank' href='https://g.page/r/CStClaj51bCbEBM/review' style={{textDecoration:'none', color:'black'}}>
                    <div style={{display:'flex', flexDirection:'row', alignItems:'center', justifyContent:'center', gap:'5px'}} >
                        <img src='/icons/rate.png' alt='chat-logo' style={{height:'25px', width:'25px'}}/>
                        <p className='need-help'>Rate Us</p>
                    </div>
                </a>
                <div className='delivery-timing' style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', gap: '5px' }}>
                    <img src='/icons/support.png' alt='chat-logo' style={{height:'25px', width:'25px'}}/>
                    <a href={`tel:${extraData.data.contactNumber}`} style={{textDecoration:'none', color:'black'}}><p className='need-help'>Need Help? Phone: {extraData.data.contactNumber}</p></a>
                </div>
                <a className='delivery-timing' target='blank' href='https://wa.me/message/3ZEPUXZXOKU5I1' style={{textDecoration:'none', color:'black'}}>
                    <div style={{display:'flex', flexDirection:'row', alignItems:'center', justifyContent:'center', gap:'5px'}} >
                        <img src='/icons/communications.png' alt='chat-logo' style={{height:'25px', width:'25px'}}/>
                        <p className='need-help'>Chat With Us</p>
                    </div>
                </a>
                {
                    status !== 'Delivered' && status !== 'On The Way' && status !== 'Cancelled' ?
                        <div className='delivery-timing'>
                            <button className='cancel-order-btn' onClick={handleCancel}>Cancel Order</button>
                        </div> :
                        <div className='delivery-timing'>
                            
                        </div>
                }
            </div>
        </>    
    );
}


